import { BaseApi } from '@/api/baseApi';
import {TUseCompanyForm, TResult} from "@/pages/Companies/useCompany";


export class Company extends BaseApi {

    public async createCompany(data: TUseCompanyForm):Promise<TResult> {
        return await this.post('/create', data);
    };
}
